/**
 * Shared schoolyear-planning activity color/pattern helpers for the portal UI.
 * Activity catalog itself is loaded from the API (`/schoolyear_planning/activities`).
 */

export function activitySwatchStyle(activity) {
	if (!activity) {
		return { background: "#e0e0e0", border: "1px solid #bdbdbd" };
	}
	var pattern = activity.pattern || "solid";
	var color = activity.color || "#e0e0e0";

	if (pattern === "checkered-blue-white") {
		return {
			backgroundImage:
				"linear-gradient(45deg, #1565C0 25%, transparent 25%)," +
				"linear-gradient(-45deg, #1565C0 25%, transparent 25%)," +
				"linear-gradient(45deg, transparent 75%, #1565C0 75%)," +
				"linear-gradient(-45deg, transparent 75%, #1565C0 75%)",
			backgroundSize: "10px 10px",
			backgroundPosition: "0 0, 0 5px, 5px -5px, -5px 0",
			backgroundColor: "#ffffff",
			border: "1px solid #90a4ae"
		};
	}
	if (pattern === "checkered-red-black") {
		return {
			backgroundImage:
				"linear-gradient(45deg, #C62828 25%, transparent 25%)," +
				"linear-gradient(-45deg, #C62828 25%, transparent 25%)," +
				"linear-gradient(45deg, transparent 75%, #C62828 75%)," +
				"linear-gradient(-45deg, transparent 75%, #C62828 75%)",
			backgroundSize: "10px 10px",
			backgroundPosition: "0 0, 0 5px, 5px -5px, -5px 0",
			backgroundColor: "#212121",
			border: "1px solid #616161"
		};
	}
	if (pattern === "checkered-yellow-black") {
		return {
			backgroundImage:
				"linear-gradient(45deg, #FDD835 25%, transparent 25%)," +
				"linear-gradient(-45deg, #FDD835 25%, transparent 25%)," +
				"linear-gradient(45deg, transparent 75%, #FDD835 75%)," +
				"linear-gradient(-45deg, transparent 75%, #FDD835 75%)",
			backgroundSize: "10px 10px",
			backgroundPosition: "0 0, 0 5px, 5px -5px, -5px 0",
			backgroundColor: "#212121",
			border: "1px solid #616161"
		};
	}
	if (pattern === "stripes-yellow-red") {
		return {
			backgroundImage:
				"repeating-linear-gradient(0deg, #FDD835 0 6px, #E53935 6px 12px)",
			border: "1px solid #bdbdbd"
		};
	}
	if (pattern === "solid-border") {
		return {
			background: color,
			border: "1px solid #424242"
		};
	}
	return {
		background: color,
		border: "1px solid rgba(0,0,0,0.15)"
	};
}
